import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Tab from 'src/Components/shared/Tab'
import { setAffordabilityMethod } from 'src/actions/affordability'
import { selectModalMethod } from 'src/store/selectors/affordability'

import styles from './AffordabilityTabs.module.scss'

const PREQUAL = 'prequal'
const CALCULATOR = 'calculator'
const PRICEPOINT = 'pricePoint'

const propTypes = {
  className: PropTypes.string,
  hide: PropTypes.bool,
}

const AffordabilityTabs = ({ className, hide, ...restProps }) => {
  const dispatch = useDispatch()
  const activeTab = useSelector(state => selectModalMethod(state))

  const handleClick = selectedTab => {
    dispatch(setAffordabilityMethod(selectedTab))
  }

  if (hide) {
    return null
  }

  return (
    <div className={classnames(className, styles.root)} {...restProps}>
      <Tab
        className={styles.tab}
        active={activeTab === PREQUAL}
        onClick={() => handleClick(PREQUAL)}
      >
        <FormattedMessage
          id='Affordability.modal.prequalTabLabel'
          defaultMessage='Prequalify'
        />
      </Tab>
      <Tab
        className={styles.tab}
        active={activeTab === CALCULATOR}
        onClick={() => handleClick(CALCULATOR)}
      >
        <FormattedMessage
          id='Affordability.modal.calculatorTabLabel'
          defaultMessage='Calculate'
        />
      </Tab>
      <Tab
        className={styles.tab}
        active={activeTab === PRICEPOINT}
        onClick={() => handleClick(PRICEPOINT)}
      >
        <FormattedMessage
          id='Affordability.modal.pricePointTabLabel'
          defaultMessage='Guess'
        />
      </Tab>
    </div>
  )
}

AffordabilityTabs.propTypes = propTypes

export default AffordabilityTabs
